import Api from '@/services/Api'
import { saveAs } from 'file-saver';

export default {
  getAll(params) {
    return Api().get(`files/`, {
      params
    })
  },
 
  uploadFile(data, optional) {
    return Api().post('files/upload', data, optional)
  },

  uploadTestFile(data, optional) {
    return Api().post('files/upload/test', data, optional)
  },

  uploadPrpFile(data, optional) {
    return Api().post('files/upload/prp', data, optional)
  },

  createDocument(data) {
    return Api().post(`files/`, data)
  },

  deleteById(id) {
    return Api().delete(`files/${id}`)
  },

  getCodeForDownload(id) {
    return Api().get(`files/downloadcode/${id}`)
  },

  evidenceCount(data) {
    return Api().post(`files/evidencecount`, data)
  },

  createDownloadUrl(str) {
    return `${process.env.VUE_APP_URL}/api/v1/files/download/${str}`
  },

  downloadDocument(id, fileName , os) {
    Api().get(`files/downloadapp/${id}?os=${os}`, { responseType: 'blob' })
      .then(response => {
        saveAs(response.data, fileName);
      })
  },
  
  getFileToken(data) {
    return Api().post(`files/getfiletoken`, data)
  },
}
